import {
    AttachmentLocalComputerFilePickerProps,
    IAttachmentLocalComputerFilePicker,
} from './components/AttachmentLocalComputerFilePicker';
export {
    AttachmentLocalComputerFilePickerProps,
    IAttachmentLocalComputerFilePicker,
} from './components/AttachmentLocalComputerFilePicker';
export { AttachmentFileList } from 'owa-attachment-file-types';
import {
    createLazyComponent,
    LazyAction,
    LazyImport,
    LazyModule,
    LazyModuleType,
} from 'owa-bundling';
export {
    default as AttachmentDataProviderType,
} from 'owa-service/lib/contract/AttachmentDataProviderType';
export {
    CreateAttachmentHandler,
    CreateAttachmentHandlerParams,
} from './types/CreateAttachmentHandler';
export { InsertLinkHandler, InsertLinkHandlerParams } from './types/InsertLinkHandler';
export {
    FileProviderItemViewState,
    FileSelectionFilter,
    FilePickerAction,
    SelectedFilesSource,
    lazyPreloadFilePicker as lazyInitializeAttachmentFilePicker,
    SizeLimitInKbToSuggestSharing,
    FilePickerUploadConfiguration,
    FilePickerConfiguration,
    ComposeUniqueState,
} from 'owa-filepicker';

/* This package is supposed to encapsulate all the attachment logic around owa-filepicker */
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentFilePicker", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded actions
export const lazyAttachmentFilePicker = new LazyAction(lazyModule, m => m.attachmentFilePicker);

// Delay loaded imports

// the following can be used to show the actions panel independent of the filepicker
export const lazyAttachmentActionsPanel = new LazyAction(lazyModule, m => m.attachmentActionsPanel);

// Delay loaded components
export const AttachmentLocalComputerFilePicker = createLazyComponent<
    AttachmentLocalComputerFilePickerProps,
    LazyModuleType<typeof lazyModule>,
    IAttachmentLocalComputerFilePicker
>(lazyModule, m => m.AttachmentLocalComputerFilePicker);

// delay loaded utility functions
export const lazyLogAttachOrShareDatapoint = new LazyImport(
    lazyModule,
    m => m.logAttachOrShareDatapoint
);
